/*
 * @Author: 
 * @Date: 2021-01-11 09:30:38
 * @LastEditors: soul(佘家骏) 
 * @LastEditTime: 2022-10-17 10:01:37
 * @Description: file content
 * 
 */
// const Mock = require('mockjs');
// import baseFakeData from "./base-fake-data";
export default {
    protocol: "",
    domain: "",
    action: {
        // 获取砍价列表
        getBargainListIndex:{
            api: "circle-act-game-assistance/act/m/page/getBargainList",
            method:'get',
            contentType:'json',
        },
        // 获取我的砍价列表
        getMyBargainList:{
            api: "circle-act-game-assistance/act/m/prize/getMyBargainList",
            method:'get',
            contentType:'json',
        },
        // 用户当前砍价状态 0未开始 1 进行中 2 已达金额
        getBargainStatus:{
            api: "circle-act-game-assistance/act/m/user/getBargainStatus",
            method:'get',
            contentType:'json',
        },
        // 获取用户当前砍价奖品
        getUserCurBargain:{
            api: "circle-act-game-assistance/act/m/prize/getUserCurBargain",
            method:'get',
            contentType:'json',
        },
        // 获取帮砍好友信息
        getBargainHelper:{
            api: "circle-act-game-assistance/act/m/user/getBargainHelper",
            method:'get',
            contentType:'json',
        },
        // 发起砍价
        launchBargain:{
            api: "circle-act-game-assistance/act/m/user/launchBargain",
            method:'post',
            contentType:'json',
            type:'body'
        },
        // 锁定砍价红包
        lockBargainRedPac:{
            api: "circle-act-game-assistance/act/m/prize/lockBargainRedPac",
            method:'post',
            contentType:'json',
            type:'body'
        },
        // 自砍
        selfBargain:{
            api: "circle-act-game-assistance/act/m/user/selfBargain",
            method:'post',
            contentType:'json',
            type:'body'
        },
        // 取消砍价
        cancelBargain:{
            api: "circle-act-game-assistance/act/m/prize/cancelBargain",
            method:'post',
            contentType:'json',
            type:'body'
        },
        // 领取砍价商品
        receiveBargain:{
            api: "circle-act-game-assistance/act/m/prize/receiveBargain",
            method:'post',
            contentType:'json',
            type:'body'
        },
        // 帮砍
        helpBargain:{
            api: "circle-act-game-assistance/act/m/user/helpBargain",
            method:'post',
            contentType:'json',
            type:'body'
        },
    },
}